ACC.paginationsort = {

    downUpKeysPressed: false,

    bindAll() {
        this.bindPaginationSort();
    },
    bindPaginationSort() {
        const { bindSortForm } = ACC.paginationsort;

        if (bindSortForm) {
            bindSortForm($('#sortForm1'));
            bindSortForm($('#sortForm2'));
        }

        // [Sep 08, 2021] Removed as failing babel pipeline
        // with (ACC.paginationsort)
        // {
        // bindSortForm($('#sortForm1'));
        // bindSortForm($('#sortForm2'));
        // }
    },
    bindSortForm(sortForm) {
        //  browser.msie has been removed from jQuery as of version 1.9.
        //  Modernizr is recommended as a replacement
        // issue created
        // if ($.browser.msie) {
        // this.sortFormIEFix($(sortForm).children('select'), $(sortForm).children('select').val());
        // }

        sortForm.change(function () {
            // if (!$.browser.msie) {
            //    this.submit();
            // }
            // else {
            if (!ACC.paginationsort.downUpPressed) {
                this.submit();
            }
            ACC.paginationsort.downUpPressed = false;
            // }
        });
    },
    sortFormIEFix(sortOptions, selectedOption) {
        sortOptions.keydown(function (e) {
            // Pressed up or down keys
            if (e.keyCode === 38 || e.keyCode === 40) {
                ACC.paginationsort.downUpPressed = true;
            } else if (e.keyCode === 13 && selectedOption !== $(this).val()) {
                // if enter
                $(this).parent().submit();
            } else {
                ACC.paginationsort.downUpPressed = false;
            }
        });
    },
};

$(document).ready(() => {
    ACC.paginationsort.bindAll();
});
